export const RAFFLE_EVENT_STATUS = {
  /** 대기중 */
  PENDING: 'PENDING',
  /** 예약됨 */
  SCHEDULED: 'SCHEDULED',
  /** 진행중 */
  IN_PROGRESS: 'IN_PROGRESS',
  /** 완료됨 */
  COMPLETED: 'COMPLETED',
  /** 상태 미지정 */
  RAFFLE_EVENT_STATUS_UNSPECIFIED: 'RAFFLE_EVENT_STATUS_UNSPECIFIED',
} as const;

export const RAFFLE_EVENT_STATE = {
  /** 활성 상태 */
  ACTIVE: 'ACTIVE',
  /** 삭제됨 */
  DELETED: 'DELETED',
  /** 상태 미지정 */
  RAFFLE_EVENT_STATE_UNSPECIFIED: 'RAFFLE_EVENT_STATE_UNSPECIFIED',
} as const;

export const RAFFLE_ENTRY_RESULT = {
  /** 당첨 */
  WIN: 'WIN',
  /** 낙첨 */
  LOSS: 'LOSS',
  /** 중복 참여 */
  DUPLICATE: 'DUPLICATE',
  /** 이벤트 종료 */
  CLOSED: 'CLOSED',
} as const;

export type RaffleEventStatus =
  (typeof RAFFLE_EVENT_STATUS)[keyof typeof RAFFLE_EVENT_STATUS];
export type RaffleEventState =
  (typeof RAFFLE_EVENT_STATE)[keyof typeof RAFFLE_EVENT_STATE];
export type RaffleEntryResult =
  (typeof RAFFLE_ENTRY_RESULT)[keyof typeof RAFFLE_ENTRY_RESULT];

export interface RepresentativeRaffleEvent {
  /** 이벤트 ID */
  id: string;
  /** 그룹 ID */
  groupId: string;
  /** 시작 시간 (ISO 8601) */
  startAt: string;
  /** 종료 시간 (ISO 8601) */
  endAt: string;
  /** 이벤트 상태 */
  status: RaffleEventStatus;
  /** 이벤트 활성 상태 */
  state: RaffleEventState;
  /** 이벤트 이미지 URL */
  imageUrl: string;
  /** 참여 버튼 텍스트 */
  buttonText: string;
}

export interface RaffleEventParams {
  /** 쿠폰 래플 그룹 ID */
  groupId: string;
}

export interface RaffleEventResponse {
  couponRaffleEvent: RepresentativeRaffleEvent;
}

export interface RaffleEntryParams {
  /** 이벤트 ID */
  eventId: string;
  /** 기획전 ID */
  exhibitionId: string;
}

export interface RaffleEntryResponse {
  /** 래플 참여 결과 */
  result: RaffleEntryResult;
  /** 당첨 시 쿠폰 정보 */
  couponMold?: {
    /** 쿠폰 ID */
    id: string;
    /** 쿠폰 이름 */
    name: string;
  };
}
